import React from 'react';

/** One label/value line in a wizard's review step. */
function ReviewRow({ label, value }) {
  return (
    <div className="review-row">
      <span className="review-label">{label}</span>
      <span className="review-value">{value}</span>
    </div>
  );
}

export default ReviewRow;
